import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function LifestyleGallerySection() {
  const images = [{
    src: 'https://images.unsplash.com/photo-1581579438747-104c53d7fbc4?w=600&q=80',
    alt: 'Senior woman smiling confidently',
    caption: 'Smile with confidence'
  }, {
    src: 'https://images.unsplash.com/photo-1529543544282-ea99407407c1?w=600&q=80',
    alt: 'Family enjoying dinner together',
    caption: 'Eat without worry'
  }, {
    src: 'https://images.unsplash.com/photo-1574279606130-09958dc756f7?w=600&q=80',
    alt: 'Senior laughing joyfully',
    caption: 'Laugh freely again'
  }, {
    src: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&q=80',
    alt: 'Confident couple enjoying outdoors',
    caption: 'Live life fully'
  }];
  return <section className="py-16 md:py-20 bg-white" data-id="element-228">
      <div className="container mx-auto px-4 md:px-6" data-id="element-229">
        <div className="text-center mb-10" data-id="element-230">
          <p className="text-red-600 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-231">
            Life With Dentafix™
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-serif" data-id="element-232">
            Rediscover the Moments That Matter
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-233">
          {images.map((img, index) => <div key={index} className="group relative rounded-2xl overflow-hidden shadow-lg" data-id="element-234">
              <img src={img.src} alt={img.alt} className="w-full h-56 md:h-72 object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-235" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end" data-id="element-236">
                <p className="text-white font-bold p-4 text-lg" data-id="element-237">
                  {img.caption}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-10" data-id="element-238">
          <CTAButton text="Join 50,000+ Happy Customers" data-id="element-239" />
        </div>
      </div>
    </section>;
}